import PubSub from 'vanilla-pubsub'
import projectBase from '../projectBase'

export default class MatchHeight {
  constructor(selector) {
    this.el = document.querySelectorAll(selector)
    this.state = {}

    if (this.el.length) {
      window.addEventListener('load', () => {
        this.initialize()
        this.bind()
      })
    }
  }

  initialize() {
    this.state.isMobile = projectBase.state.isMobile
    this.instance = [...this.el].map((el) => {
      const MatchHeight = {
        el: [...el.querySelectorAll('[data-mh]')],
      }

      MatchHeight.update = () => {
        const heightArr = MatchHeight.el.map((el) => el.clientHeight)
        const equalHeight = Math.max(...heightArr)

        MatchHeight.el.map((el) => {
          el.style.minHeight = `${equalHeight}px`
        })
      }

      MatchHeight.clear = () => {
        MatchHeight.el.forEach((el) => {
          el.style.minHeight = ''
        })
      }

      el.MatchHeight = MatchHeight
      return MatchHeight
    })

    this.update()
  }

  update() {
    this.instance.forEach((instance) => {
      instance.update()
    })
  }

  clear() {
    this.instance.forEach((instance) => {
      instance.clear()
    })
  }

  bind() {
    this._onResize = this._onResize.bind(this)
    PubSub.subscribe('App.resize', this._onResize)
  }

  _onResize({ isMobile }) {
    const oldState = this.state.isMobile
    this.state.isMobile = isMobile

    if (oldState !== this.state.isMobile) {
      this._onChangeViewport()
    }
  }

  /**
   * ブレークポイントを跨ぐリサイズが行われた場合に発火
   */
  _onChangeViewport() {
    if (this.state.isMobile) {
      this.clear()
    } else {
      this.update()
    }
  }
}
